import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject, Subscription } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { IUser } from '../../../shared/models';
import {
  AuthService, EventsService, SeoService, StorageService, UtilService, VariablesService, VwoService
} from '../../../shared/services';

@Component({
  selector: 'app-referral-main',
  templateUrl: './referral-main.component.html',
  styleUrls: ['./referral-main.component.scss'],
})
export class ReferralMainComponent implements OnInit, OnDestroy, AfterViewInit {
  tags;
  isBtnVisible;
  inviewPort = {
    donationForm: false,
    isDonationFormShowed: false,
    isDockedForMobile: true,
  };
  isMobile: any;
  isIos;
  @ViewChild('donationDock') donationDock: ElementRef;
  hideDonateDocker = false;
  public params;
  public currency = 'INR';
  public userdata: IUser;
  eventsSubject = new Subject<any>();
  isBannerCLicked = false;

  activatedOffer;
  globalVar;
  offerpriority = false;
  text = true;

  loadAfterVwo = false;
  showTruecallerPopup = false;
  nudge = false;
  multicauseParamDMTrue = false;

  subs: Subscription[] = [];

  constructor(
    public variablesService: VariablesService,
    public util: UtilService,
    private events: EventsService,
    private actRoute: ActivatedRoute,
    private authService: AuthService,
    public vwo: VwoService,
    private seo: SeoService,
    public storage: StorageService
  ) { }

  ngOnInit() {
    this.nudge = this.storage.getFromSession('welcome-nudge');
    this.isMobile = this.util.isMobile();
    this.isIos = this.util.isIOSDevice();
    this.addFAQSchema();
    this.variablesService.pageName = 'impact_portfolio_stories';
    this.variablesService.campaignType = 'impact_portfolio_stories';
    this.pageViewEvent();
    this.addTags();
    this.actRoute.queryParams.subscribe((params) => {
      this.params = params;
    });
    if (this.actRoute.snapshot.queryParams.st === 'f') {
      this.util.router.navigate([], { queryParams: { page: 'op' }, queryParamsHandling: 'merge' });
    }
    if (this.params?.utm_source?.match('external_ct') && this.params?.utm_medium?.match('whatsapp|email') && this.params?.utm_campaign?.match('sip_monthly_reminder_comm')) {
      this.multicauseParamDMTrue = true;
    }
    this.variablesService.mainLayoutConfig.next({
      showHeader: true,
      showFooter: this.isMobile ? false : true,
      hideAbandonedCart: true,
      logoNavigate: true,
      showProfile: true,
      showCurrency: this.vwo.multi_cause_dm_AB() || this.multicauseParamDMTrue ? true : false
    });
    this.variablesService.userData.subscribe(res => this.userdata = res);

    this.subs.push(this.variablesService.offerActivated.subscribe(res => {
      this.activatedOffer = res;
    }));

    this.subs.push(this.variablesService.globalVar.subscribe({
      next: (resp) => {
        this.globalVar = resp;
      }
    }));

    if (this.params['offer'] && this.params['rewards']) {
      this.offerpriority = true;
    }

    if (this.params['rewards']) {
      this.text = false;
      this.variablesService.event_info.info_1 = 'Benefits_&_Rewards';
    }

    this.prefill();

    setTimeout(() => {
      this.loadAfterVwo = true;
    }, 600);
    this.storage.addSessionData('dm_page_visited', true);
  }

  ngAfterViewInit(): void {
    if (this.actRoute.snapshot.queryParams.pos) {
      this.util.scrollIntoViewSmoothlyByClass(this.actRoute.snapshot.queryParams.pos, 0, -60);
    }
  }

  async prefill() {
    try {
      await this.authService.userLoginWithEmail(this.actRoute.snapshot.queryParams);
    } catch (error) { }
  }

  bannerClickList() {
    const user = this.storage.get('user');
    if (!user && this.util.isMobile() && !this.isBannerCLicked) {
      this.eventsSubject.next(null);
      this.isBannerCLicked = true;
    }
  }

  /**fixed postion */
  fixedPostion(event) {
    if (!this.util.isMobile()) {
      if (!this.inviewPort.isDonationFormShowed) {
        this.inviewPort.isDonationFormShowed = event.visible;
      }
      this.inviewPort.donationForm = event.visible;
      this.util.doc.body.style.marginBottom = event.visible ? 'auto' : '100px';
    }
  }

  addTags() {
    const keywords = `help poor child, donation for kids, save a life, donate per month, monthly donation platform, monthly donation, donation subscription, donate every month, donate money every month, charity donation subscription, children donation, sponsor a child monthly, donate monthly to charity, monthly giving campaigns, monthly giving programs, monthly giving , give recurring donations, recurring donation platform, recurring giving, give donation, child sponsorship, how to sponser a child`;
    const data = {
      title: `Gift Children New Lives With Ketto's Social Impact Plan`,
      description: `With Ketto's Social Impact Plan, you can support the medical treatment of a child in need by donating as little as Rs 100 a month.`,
      url: `${environment.APP.DOMAIN_URL}/new/sip`,
      site: 'Ketto.org',
      keywords: keywords,
      image: `${environment.APP.DOMAIN_URL}/assets/images/portfolio/father_with_child.png`,
    };
    this.tags = this.seo.createTagObject(data);
    this.seo.addMetaTags(this.tags);
    this.util.setPageTitle(data.title);
  }

  pageViewEvent() {
    const systemEvent = {
      eventName: 'pageView',
      info_3: 'impact',
      page_name: 'impact_portfolio_stories',
    };
    this.events.onLoadSystemEvent(systemEvent);

    this.events.claverTapPush('PageView', {
      'Event Name': 'PageView',
      'SIP Cause Type': this.actRoute.snapshot.queryParams?.sip_cause || 'medical'
    });
  }

  eventTrack() {
    this.events.sendSystemEvent({
      entity_type: 'give_a_life',
      event_type: 'impact',
      info_1: 'position',
      info_2: '3',
      info_3: 'impact',
      page_name: 'impact_portfolio_stories',
    }).subscribe((_) => _);
  }

  toggleDonationDock(event): void {
    if (this.donationDock) {
      if (event.visible === false) {
        this.donationDock.nativeElement.classList.remove('inactive');
        this.donationDock.nativeElement.classList.add('active');
      } else if (event.visible === true) {
        this.donationDock.nativeElement.classList.add('inactive');
        this.donationDock.nativeElement.classList.remove('active');
      }
    }
  }

  addFAQSchema(): void {
    const seoJSON = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: 'What is Social Impact Plan?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Social Impact Plan is an initiative to help these underprivileged children receive proper medical support. With a little every month, we can offer a helping hand to many. Your monthly donations can help them fight deadly diseases and give them a gift of life.',
          },
        },
        {
          '@type': 'Question',
          name: 'How are my donations being utilized?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'There are many campaigns in urgent need of funds. Every month, your donation will be transferred to a hospital for one such campaign to aid a child’s treatment and help with recovery.',
          },
        },
        {
          '@type': 'Question',
          name: 'How do I cancel my Monthly Giving?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'In case you wish to cancel your giving program <ul><li> 1. Login to your profile > Click on ‘My Donations’</li><li>2. Select ‘Turn Off My SIP’</li>',
          },
        },
        {
          '@type': 'Question',
          name: 'How can I get updates about the patients?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'You will receive consolidated monthly updates of the patients that you have supported via email and Whatsapp. Our team will also be sending you details about how your funds are being utilised.',
          },
        },

        {
          '@type': 'Question',
          name: 'Is my payment/transaction secured when I’m donating?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'All Payments are secured via 128-bit encryption. Ketto assures you that the information you provide is completely protected and that your donations are safe. Our secure-server software encrypts all your personal information including name, contact number, email ID and address. If you wish to maintain anonymity, you can click on ‘Anonymous’ while donating.',
          },
        },
        {
          '@type': 'Question',
          name: 'How are the patients verified?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'We, at Ketto, are extremely particular about the authenticity of a campaign. In order to ensure it is genuine, we follow a strict 3-step process before listing any fundraiser. The rigorous verification process involves submission of legal identity proofs and medical documents. Furthermore, the specifics of each case are verified by the concerned hospital’s medical team. All fundraisers are ‘Ketto Assured’ and they protect the donor’s interest.',
          },
        },
      ],
    };
    this.seo.schemaBodyObject(seoJSON);
  }

  textshown(text: boolean) {
    this.text = text;
    setTimeout(() => {
      if (this.params['rewards'] && this.params['offer']) {
        this.offerpriority = true;
      }
    }, 0);
  }

  showTruecaller = (e) => {
    this.showTruecallerPopup = e;
  };

  ngOnDestroy() {
    if (this.tags) {
      this.seo.removeMetaTags(this.tags);
    }

    this.subs.forEach(s => s.unsubscribe());
  }
}
